import { render } from "./LootBoxHeader.vue?vue&type=template&id=4acca703"
import script from "./LootBoxHeader.vue?vue&type=script&lang=js"
export * from "./LootBoxHeader.vue?vue&type=script&lang=js"

import "./LootBoxHeader.vue?vue&type=style&index=0&id=4acca703&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__